export const UPDATE_EVENTS = 'UPDATE_EVENTS';
export const SET_SEASON = 'SET_SEASON';
export const SET_EVENT_TYPE = 'SET_EVENT_TYPE';
export const SET_MONTH = 'SET_MONTH';
export const SET_TOURNAMENT = 'SET_TOURNAMENT';
export const LOAD_MORE_EVENTS = 'LOAD_MORE_EVENTS';
export const SET_LOADING = 'SET_LOADING';
export const RELOAD_EVENTS = 'RELOAD_EVENTS';
